import { TransactionDirection } from "../transaction/transaction-filter";

export const transactionDirectionLabels = {
  [TransactionDirection.ALL]: "transactionFilter.all",
  [TransactionDirection.INCOME]: "transactionFilter.credit",
  [TransactionDirection.OUTCOME]: "transactionFilter.debit",
};
